import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ConfirmationDialogService } from '../../../confirmation-dialog/confirmation-dialog.service';
import { LoggedInUserInfo } from '../../../../model/LoggedInUserInfo';
import { CommonService } from 'src/app/shared/services/common-service.service';
import { DataStorageService } from 'src/app/shared/services/data-storage.service';
import { environment } from 'src/environments/environment';
@Component({
  selector: 'app-my-account',
  templateUrl: './my-account.component.html',
  styleUrls: ['./my-account.component.scss']
})
export class MyAccountComponent implements OnInit {
  UserName;
  UserCode;
    EmpType?:any;
  //sosApiEndPoint = environment.sosApiEndPoint;
  constructor( private router: Router, private confirmationDialogService: ConfirmationDialogService,
    private commonService: CommonService, private api: DataStorageService) {
    // this.UserName=this.user.name;
    let user: LoggedInUserInfo = JSON.parse(localStorage.getItem('user') ?? '{}') as LoggedInUserInfo;
    // this.UserName = user.UserName;
    // console.log(this.user)
  }

  ngOnInit() {
    this.getUserInfo();
    this.EmpType =localStorage.getItem("EmpType");
  }

  async getUserInfo() {
    let UserID = localStorage.getItem("UserID");
    // console.log("UserID="+UserID)
    await this.api
      .getData("Master/GetUserDetailByID/" + parseInt(UserID))
      // .getData("User/GetEmployeeDetailById/" + parseInt(UserID))
      .subscribe((res: any) => {
        //debugger
        let list = JSON.parse(res);

        this.UserName = list.UserDetail[0].Emp_name;
        this.UserCode = list.UserDetail[0].Emp_Code;
        localStorage.setItem("user", JSON.stringify(list.UserDetail[0]));

        //console.log(list);
        // list.forEach((row) => {
        //   this.UserName = row.Emp_name;
        //   this.UserCode = row.Emp_Code;
        //   localStorage.setItem("user", JSON.stringify(row));
        // });
      });
  }
  logout() {
    this.confirmationDialogService.confirm('', 'Are you sure want to logout?')
      .then(
        confirmed => { // Success
          if (confirmed) {
            if(this.EmpType == 12){
            this.clearSession(localStorage.getItem("UserID"));
            this.commonService.deleteAllCookies();
            window.location.href = environment.intranetURL+'/cabbooking/index.html#/login/'
            //window.location.href = " https://uat.rspl.net.in/cabbooking/index.html#/login/"
            //this.commonService.logoutRedirect();
            }
            else{
            //debugger
            this.clearSession(localStorage.getItem("UserID"));
            this.commonService.deleteAllCookies();
            this.commonService.logoutRedirect();
            }
            
            // this.router.navigate(["/dashboard/default"], {
            //   skipLocationChange: true,
            // });
          }
        });
  }

  clearSession(UserID) {
    //debugger
    // this.api.postSoSData(this.sosApiEndPoint + "api/Authenticate/LogOut/" + UserID)
    //   .subscribe((data: any) => {
    //     console.log(data)
    //   });
  }
}
